(() => {
  if (window.__customSizeGuideInitialized) return;
  window.__customSizeGuideInitialized = true;

  const getModalForOpener = (opener) => {
    const block = opener.closest('.product__block--variant_picker');
    if (block) return block.querySelector('[data-size-guide-modal]');

    const variantSelects = opener.closest('variant-selects');
    return variantSelects?.parentElement?.querySelector('[data-size-guide-modal]') || null;
  };

  const getModalElements = (modal) => ({
    overlay: modal.querySelector('[data-size-guide-modal-overlay]'),
    tabs: modal.querySelectorAll('[data-size-guide-tab]'),
    tabContents: modal.querySelectorAll('[data-size-guide-content-block]'),
  });

  const isTaiwanVisitor = () => {
    let country = '';
    try {
      country = sessionStorage.getItem('detectedCountry') || '';
    } catch {
      country = '';
    }

    return country === 'TW' || location.pathname === '/tw' || location.pathname.startsWith('/tw/');
  };

  const applyMeasurementRegion = (modal) => {
    const taiwan = modal.querySelector('[data-size-guide-measurement="taiwan"]');
    const fallbacks = modal.querySelectorAll(
      '[data-size-guide-measurement="default"], [data-size-guide-measurement="japan"]'
    );

    if (isTaiwanVisitor() && taiwan) {
      fallbacks.forEach((element) => {
        element.hidden = true;
      });
      taiwan.hidden = false;
      return;
    }

    fallbacks.forEach((element) => {
      element.hidden = false;
    });
    if (taiwan) taiwan.hidden = true;
  };

  const preloadImages = (modal) => {
    const { tabContents } = getModalElements(modal);
    tabContents.forEach((content) => {
      const image = content.querySelector('img');
      if (image?.getAttribute('loading') === 'lazy') image.setAttribute('loading', 'eager');
    });
  };

  const activateTab = (modal, index) => {
    const { tabs, tabContents } = getModalElements(modal);
    tabs.forEach((tab) => tab.classList.remove('size-guide-modal__tab--active'));
    tabContents.forEach((content) => {
      content.classList.remove('size-guide-model__content--active');
      content.classList.add('size-guide-model__content--hidden');
    });

    tabs[index]?.classList.add('size-guide-modal__tab--active');
    if (tabContents[index]) {
      tabContents[index].classList.add('size-guide-model__content--active');
      tabContents[index].classList.remove('size-guide-model__content--hidden');
    }
  };

  const activateTabByContentId = (modal, contentId) => {
    const { tabs, tabContents } = getModalElements(modal);
    tabs.forEach((tab) => {
      tab.classList.toggle(
        'size-guide-modal__tab--active',
        tab.getAttribute('data-size-guide-content') === contentId
      );
    });
    tabContents.forEach((content) => {
      const isActive = content.getAttribute('data-size-guide-content-block') === contentId && !content.hidden;
      content.classList.toggle('size-guide-model__content--active', isActive);
      content.classList.toggle('size-guide-model__content--hidden', !isActive);
    });
  };

  const activateFirstTab = (modal) => {
    const { tabs } = getModalElements(modal);
    const firstTab = tabs[0];
    if (!firstTab) return;

    const contentId = firstTab.getAttribute('data-size-guide-content');
    if (contentId) {
      activateTabByContentId(modal, contentId);
    } else {
      activateTab(modal, 0);
    }
  };

  const closeModal = (modal) => {
    const { overlay } = getModalElements(modal);
    modal.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    document.querySelector('[data-main-content]')?.classList.remove('main-content--active');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const modal = getModalForOpener(opener);
      if (!modal) return;

      event.preventDefault();
      const { overlay } = getModalElements(modal);
      applyMeasurementRegion(modal);
      modal.style.display = 'block';
      if (overlay) overlay.style.display = 'block';
      document.body.classList.add('overflow-hidden');
      document.querySelector('[data-main-content]')?.classList.add('main-content--active');
      preloadImages(modal);
      activateFirstTab(modal);
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');
    if (closeButton) {
      const modal = closeButton.closest('[data-size-guide-modal]');
      if (!modal) return;
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.target.matches('[data-size-guide-modal-overlay]')) {
      const modal = event.target.closest('[data-size-guide-modal]');
      if (!modal) return;
      event.preventDefault();
      closeModal(modal);
      return;
    }

    const clickedTab = event.target.closest('[data-size-guide-tab]');
    if (!clickedTab) return;

    const modal = clickedTab.closest('[data-size-guide-modal]');
    if (!modal) return;
    const contentId = clickedTab.getAttribute('data-size-guide-content');
    if (contentId) {
      activateTabByContentId(modal, contentId);
    } else {
      activateTab(modal, Number.parseInt(clickedTab.getAttribute('data-size-guide-tab'), 10) - 1);
    }
  });
})();
